<template>
  <div>
    <v-navigation-drawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
    >
      <v-list dense>
        <template v-for="item in authorizedPages">
          <v-row
              v-if="item.heading"
              :key="item.heading"
              align="center"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col
                cols="6"
                class="text-center"
            >
              <a
                  href="#!"
                  class="body-2 black--text"
              >EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
              v-else-if="item.children"
              :key="item.text"
              v-model="item.model"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon=""
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
                v-for="(child, i) in item.children"
                :key="i"
                link
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
              v-else
              :key="item.text"
              link
              @click="$router.push(item.route)"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        color="orange darken-3"
        dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title
          style="width: 300px"
          class="ml-0 pl-4"
      >
        <span class="hidden-sm-and-down">Avrupa Gençlik Derneği</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!--<v-btn icon>
        <v-icon>mdi-email</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>

      <v-menu
          left
          bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              icon
              v-bind="attrs"
              v-on="on"
          >
            <v-avatar size="32px" item>
              <v-img
                  src="https://cdn.vuetifyjs.com/images/logos/logo.svg"
                  alt="Vuetify"></v-img>
            </v-avatar>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="logOut">
            <v-list-item-title>Çıkış</v-list-item-title>
            <v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon>
          </v-list-item>
        </v-list>

      </v-menu>-->
      <v-btn @click="logOut" icon>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
      <!--<v-btn icon large>
        <v-avatar size="32px" item>
          <v-img
              src="https://cdn.vuetifyjs.com/images/logos/logo.svg"
              alt="Vuetify"></v-img>
        </v-avatar>
      </v-btn>-->
    </v-app-bar>
    <v-main>

      <v-container fluid>
          <router-view/>
      </v-container>
    </v-main>
  </div>
</template>


<script>
import {routes} from '@/router'

export default {
  name: "Dashboard",
  data: () => ({
    drawer: null,
    items: [
      { icon: 'mdi-home', text: 'Anasayfa' , route: {name: 'Student'}},
/*      { icon: 'mdi-television-play', text: 'Canlı Ders' },
      { icon: 'mdi-calendar', text: 'Ders Programı' },*/
      { icon: 'mdi-book-open', text: 'Derslerim' , route: {name: 'Lecture'} },
      { icon: 'mdi-clipboard-edit', text: 'Yönetici Paneli' , route: {name: 'EditManager'} },
      { icon: 'mdi-clipboard-edit', text: 'Öğretmen Paneli' , route: {name: 'EditTeacher'} },
      { icon: 'mdi-clipboard-edit', text: 'Sınıf Paneli' , route: {name: 'EditClassroom'} },
      { icon: 'mdi-clipboard-edit', text: 'Öğrenci Paneli' , route: {name: 'EditStudent'} },
      { icon: 'mdi-clipboard-edit', text: 'Aktivite Paneli' , route: {name: 'EditActivity'} },
      { icon: 'mdi-clipboard-edit', text: 'Ders Paneli' , route: {name: 'EditLecture'} },
      { icon: 'mdi-clipboard-edit', text: 'Ezber Paneli' , route: {name: 'EditEzber'} },
      { icon: 'mdi-clipboard-edit', text: 'Ödev Paneli' , route: {name: 'EditHomework'} },
      { icon: 'mdi-clipboard-edit', text: 'Ödevlerim' , route: {name: 'Homework'} },
/*      {
        icon: 'mdi-chevron-up',
        'icon-alt': 'mdi-chevron-down',
        text: 'Testler',
        model: false,
        children: [
          { text: 'Testler' },
          { text: 'Test Sonuçları' },
        ],
      },
      {
        icon: 'mdi-chevron-up',
        'icon-alt': 'mdi-chevron-down',
        text: 'Online Destek',
        model: false,
        children: [
          { text: 'Öğrencilerden Gelenler' },
        ],
      },
      { icon: 'mdi-account-circle', text: 'Profilim' },
      { icon: 'mdi-message', text: 'Yardım' },*/
    ],
  }),
  methods: {
    logOut: function () {
      this.$store.dispatch('logOut')
          .then(() => this.$router.push('/'))
    },

  },
  computed: {
    authorizedPages: function (){
      const cls = this.$store.getters.user.cls
      const dashboardRoutes = routes.find(route => route.name === 'Dashboard').children
      return this.items.filter(item => dashboardRoutes.find(route => route.name === item.route.name).meta.requiresCls.includes(cls))
    }
  }
}
</script>
